// Post limits
export const POST_CHAR_LIMIT = 500;
export const POST_CHAR_LIMIT_ADMIN = 5000;
// Languages
export const LANGUAGES = ['en', 'ru', 'pt', 'es', 'he'];
export const LANGUAGE_LABELS = {
    en: 'English',
    ru: 'Русский',
    pt: 'Português',
    es: 'Español',
    he: 'עברית',
};
export const RTL_LANGUAGES = ['he'];
// Languages actually selectable/rendered today (Hebrew is stubbed — see
// LANGUAGES above). Used both for UI language selection and for validating
// admin-authored translated content (e.g. category names).
export const ACTIVE_LANGUAGES = ['en', 'ru', 'pt', 'es'];
// Post types
export const POST_TYPES = ['post', 'event', 'offer', 'help', 'action'];
// Post types that can carry an admin-curated category (see Category below).
// Plain posts never do.
export const CATEGORIZABLE_POST_TYPES = ['event', 'offer', 'help', 'action'];
// Everything a Category's `appliesTo` can be scoped to — the 4 categorizable
// post types, plus Group (spec-search-fase3-groups.md; Group isn't a
// PostType, so it can't just join CATEGORIZABLE_POST_TYPES). Plain posts are
// still never categorizable.
export const CATEGORY_APPLIES_TO_VALUES = [...CATEGORIZABLE_POST_TYPES, 'group'];
// Offer types
export const OFFER_TYPES = ['good', 'service'];
// Capabilities granted by badges
export const CAPABILITIES = [
    'moderate',
    'delete_any_post',
    'ban_user',
    'grant_badges',
    'manage_categories',
    'super',
];
// System badge slugs
export const SYSTEM_BADGE_SLUGS = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    PIONEER: 'pioneer',
    COMMUNITY_SUPERHERO: 'community_superhero',
    GROUP_ADMIN: 'group_admin',
    GROUP_EDITOR: 'group_editor',
};
// Pioneer cutoff dates
export const PIONEER_FOUNDING_CUTOFF = '2026-09-30';
export const PIONEER_CUTOFF = '2026-12-31';
// Badge scope — 'global' badges (super_admin, admin, pioneer, ...) apply
// everywhere; 'group' badges (group_admin, group_editor) only carry meaning
// inside the group_id they were granted for.
export const BADGE_SCOPES = ['global', 'group'];
// Who can grant a badge: 'system' badges are seeded/auto-granted (signup,
// group creation) and never grantable through the API; 'group_admin' badges
// are grantable by a group's own group_admin holders via the group badge
// grant endpoint.
export const BADGE_ISSUABLE_BY = ['system', 'group_admin'];
// Capability strings for group-scoped badges. Distinct from CAPABILITIES
// (which backs the global, JWT-baked AccountCapabilities shape) — these are
// checked per-group via requireGroupCapability, not the global auth context.
export const GROUP_CAPABILITIES = [
    'invite_member',
    'manage_members',
    'grant_group_badges',
    'edit_group',
    'post_as_group',
    'manage_actions',
];
// Feed types — the "lens" (Nível 1 nav). Events/Bazaar are no longer
// separate feeds; they're post-type filter chips (Nível 2) layered on top
// of Local/Following.
export const FEED_TYPES = ['local', 'following'];
// Post type icons (lucide-react icon names)
export const POST_TYPE_ICONS = {
    post: null,
    event: 'Calendar',
    offer: 'Gift',
    help: 'LifeBuoy',
    action: 'Zap',
};
// RSVP visibility for an Action — 'group_members' is implicit for closed
// groups (enforced server-side regardless of what's sent); open groups let
// the creator choose 'everyone' instead.
export const RSVP_VISIBILITY = ['group_members', 'everyone'];
export const OFFER_TYPE_ICONS = {
    good: 'Gift',
    service: 'Handshake',
};
// Animal avatars (default avatars)
export const ANIMAL_AVATARS = [
    'bear',
    'cat',
    'deer',
    'elephant',
    'fox',
    'hedgehog',
    'koala',
    'lion',
    'owl',
    'panda',
    'rabbit',
    'wolf',
];
// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 50;
export const MAX_REPLIES_PREVIEW = 5;
// Feed
export const FEED_CTA_INTERVAL = 5; // show CTA card every N posts for unauth users
// Report status
export const REPORT_STATUSES = ['pending', 'reviewed', 'dismissed'];
// Notification types
export const NOTIFICATION_TYPES = [
    'follow',
    'boost',
    'translation_boost',
    'mention',
    'dm',
    'reply',
    'report',
    'badge_granted',
    'claps_digest',
];
// File upload
export const ALLOWED_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
];
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
// Profile
export const MAX_BIO_LENGTH = 500;
export const MAX_LINKS = 8;
export const MAX_DISPLAY_NAME_LENGTH = 64;
export const MAX_ADDRESS_LENGTH = 100;
// Account type — 'group' accounts are mirror accounts for a `groups` row,
// never authenticate, and exist so a group can author posts/hold badges
// through the same `accounts` table as regular users.
export const ACCOUNT_TYPES = ['user', 'group'];
// Regions (Israel) — used to filter/group community groups by area.
// 'all' is an explicit statement ("this group serves the whole country"),
// distinct from a group leaving region unset (null = unspecified).
export const REGIONS = ['north', 'center', 'south', 'all'];
// Group membership
export const GROUP_MEMBER_STATUSES = ['invited', 'requested', 'active'];
export const GROUP_MEMBER_INITIATED_BY = ['group', 'user'];
export const MAX_GROUP_NAME_LENGTH = 64;
export const MAX_GROUP_DESCRIPTION_LENGTH = 500;
// ActivityPub / Federation (stubs — used when federation is implemented)
export const AP_CONTEXT = 'https://www.w3.org/ns/activitystreams';
export const AP_PUBLIC = 'https://www.w3.org/ns/activitystreams#Public';
//# sourceMappingURL=index.js.map